// extracted by mini-css-extract-plugin
module.exports = {"ToolsBody":"ReplaceSpaces_ToolsBody__pBsob","Input":"ReplaceSpaces_Input__gM9Eq"};